import breakpoints from './breakpoints';
import colors from './colors';
import {
  alert,
  accordion,
  buttonSizes,
  buttons,
  featureGrid,
  quote,
  cards,
  form,
  headings,
  hero,
  links,
  logoSection,
  nav,
  paper,
  peopleSection,
  tileSizes,
  videoCarousel,
  videoPlayer,
  wave,
} from './components';
import * as shared from './shared/index';
import fonts from './fonts';
import fontSizes from './font-sizes';
import keyframe from './keyframes';
import radii from './radii';
import shadows from './shadows';
import space from './space';
import typography from './typography';
import zIndices from './z-indices';
import { LucidTheme } from '../types/lucid-theme';

const theme: LucidTheme = {
  ...fonts,
  breakpoints,
  colors,
  fontSizes,
  radii,
  shadows,
  space,
  zIndices,
  // keyframe
  keyframe,
  // shared
  shared,
  // components
  alert,
  accordion,
  buttonSizes,
  buttons,
  quote,
  cards,
  featureGrid,
  form,
  headings,
  hero,
  links,
  logoSection,
  nav,
  paper,
  peopleSection,
  tileSizes,
  typography,
  videoCarousel,
  videoPlayer,
  wave,
};

export { theme };
export default theme;
